import { Component, OnDestroy, inject } from '@angular/core';
import { Settings } from '../../../core/Interfaces/settings';
import { SettingsService } from '../../../core/services/settings.service';
import { MatFormField, MatInput, MatLabel } from '@angular/material/input';
import { MatCard } from '@angular/material/card';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-settings-redemptions-log-size',
  imports: [MatInput, MatLabel, MatCard, FormsModule, MatFormField],
  templateUrl: './redemptions-log-size.component.html',
  styleUrl: './redemptions-log-size.component.scss',
})
export class RedemptionsLogSizeComponent implements OnDestroy {
  private settingsService = inject(SettingsService);

  sub;
  settings: Settings | undefined;

  constructor() {
    this.sub = this.settingsService.getSubject().subscribe((value) => {
      this.settings = value;
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  change() {
    if (!this.settings) {
      return;
    }
    if (this.settings.redemptionQueSize) {
      this.settingsService.updateQueSize(this.settings.redemptionQueSize);
    }
  }
}
